import React from "react";

function FormattedDate({ date }) {
  // Convert input (string, Date object, timestamp) to Date object
  const dateObj = new Date(date);

  // Helper to get formatted month name (3-letter capitalized)
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const day = dateObj.getDate(); // Day of month (1-31)
  const month = monthNames[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  // Hours and minutes, padded with 0 if needed
  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  return (
    <time
      dateTime={dateObj.toISOString()}
      
      aria-label={`Date and time: ${day} ${month}, ${year} ${hours}:${minutes}`}
    >
      {`${day} ${month}, ${year} ${hours}:${minutes}`}
    </time>
  );
}

export default FormattedDate;
